import { FIELDS } from './constants';

const defaultFields = [
  {
    key: 'id',
    field: FIELDS.ID,
    title: 'Id',
    label: 'id',
    cell: 'navigation',
    sortable: true,
    hidden: false,
    width: 70 ,
  },
  {
    key: 'shippingProviderId',
    field: FIELDS.SHIPPING_PROVIDER_ID,
    title: 'Shipping Provider Id',
    label: 'shippingProviderId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'shippingProviderName',
    field: FIELDS.SHIPPING_PROVIDER_NAME,
    title: 'Shipping Provider Name',
    label: 'shippingProviderName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'name',
    field: FIELDS.NAME,
    title: 'Name',
    label: 'name',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'shippingDays',
    field: FIELDS.SHIPPING_DAYS,
    title: 'Shipping Days',
    label: 'shippingDays',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'shippingAccount',
    field: FIELDS.SHIPPING_ACCOUNT,
    title: 'Shipping Account',
    label: 'shippingAccount',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'createdByUserId',
    field: FIELDS.CREATED_BY_USER_ID,
    title: 'Created By User Id',
    label: 'createdByUserId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'createdByUserFullName',
    field: FIELDS.CREATED_BY_USER_FULL_NAME,
    title: 'Created By User Full Name',
    label: 'createdByUserFullName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'modifiedByUserId',
    field: FIELDS.MODIFIED_BY_USER_ID,
    title: 'Modified By User Id',
    label: 'modifiedByUserId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'modifiedByUserFullName',
    field: FIELDS.MODIFIED_BY_USER_FULL_NAME,
    title: 'Modified By User Full Name',
    label: 'modifiedByUserFullName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'dateCreated',
    field: FIELDS.DATE_CREATED,
    title: 'Date Created',
    label: 'dateCreated',
    cell: 'formatDate',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'dateModified',
    field: FIELDS.DATE_MODIFIED,
    title: 'Date Modified',
    label: 'dateModified',
    cell: 'formatDate',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'active',
    field: FIELDS.ACTIVE,
    title: 'Active',
    label: 'active',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    field: '',
    title: '',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;
